import React, { useMemo } from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Map, Set } from 'immutable';
import t from '../../lib/I18n';
import Icon from '../general/Icon';
import { StationTypes } from '../../constants/AppConstants';
import { StationSelector } from '../search/StationSelector';
import Search from '../../records/Search';
import SectionErrors from '../search/SectionErrors';


const AddJourneyModalTravelForm = ({
    search,
    searchErrors,
    setSearch,
    setIsChangedStation
}) => {
    const errors = useMemo(() => {
        let errs = new Map();
        if (searchErrors.has('validateStationsNotEqual')) {
            errs = errs.set('origin', 'booking.journey.errors.sameStation')
                .set('destination', 'booking.journey.errors.sameStation');
        }

        return errs;
    }, [searchErrors]);

    const handleStationChange = (name, currentStation) => {
        setIsChangedStation(true);
        setSearch(search.set(name, currentStation));
    };

    const renderStation = (name, type) => {
        const placeholder = t(`booking.journey.${name}`);

        return (
            <StationSelector
                className="journey-modal-info-field"
                excludeGroupStations
                onChange={currentStation => handleStationChange(name, currentStation)}
                station={search[name]}
                placeholder={placeholder}
                stationType={type}
                name={name}
            />
        );
    };

    return (
        <React.Fragment>
            <Col xs={12} className="journey-modal-info-title margin-top--sm">
                {t('auto-dr.account.subscribe.journeys.modal.info')}
            </Col>
            <Col xs={12} className="journey-modal-info-errors">
                <SectionErrors errors={errors.toSet().toList().toArray()} />
            </Col>
            <Col sm={ 5 } xs={ 12 } className="journey-modal-info-field-col margin-top--sm margin-bottom--sm">
                <Icon icon="mandatory" className="journey-modal-info-mandatory" />
                {renderStation('origin', StationTypes.ORIGIN)}
            </Col>
            <Col xs={2} className="journey-modal-info-arrowback text-center padding--vert-sm margin-top--sm margin-bottom--sm">
                <Icon icon="arrowback" className="otrl-rotate-180 journey-modal-info-arrow" />
            </Col>
            <Col sm={ 5 } xs={ 12 } className="journey-modal-info-field-col margin-top--sm margin-bottom--sm">
                <Icon icon="mandatory" className="journey-modal-info-mandatory" />
                {renderStation('destination', StationTypes.DESTINATION)}
            </Col>
        </React.Fragment>
    );
};


AddJourneyModalTravelForm.propTypes = {
    search: PropTypes.instanceOf(Search).isRequired,
    searchErrors: PropTypes.instanceOf(Set),
    setSearch: PropTypes.func.isRequired,
    setIsChangedStation: PropTypes.func.isRequired
};

AddJourneyModalTravelForm.defaultProps = {
    searchErrors: new Set(),
};

export default AddJourneyModalTravelForm;
